/* eslint-disable @typescript-eslint/ban-types */ import { forEachToken, isToken } from '@sail/engine';
const tokenLookupTables = new WeakMap();
function getTokenLookupTable(tokenMap) {
    if (tokenLookupTables.has(tokenMap)) {
        return tokenLookupTables.get(tokenMap);
    }
    const lookupTable = Object.create(null);
    forEachToken(tokenMap, (value, path)=>{
        lookupTable[path] = value.toString();
    });
    tokenLookupTables.set(tokenMap, lookupTable);
    return lookupTable;
}
function createTokenLookupTable(tokenMaps) {
    if (tokenMaps.length === 1) {
        return getTokenLookupTable(tokenMaps[0]);
    }
    return Object.assign(Object.create(null), ...tokenMaps.slice().reverse().map((map)=>getTokenLookupTable(map)));
}
function createTokenLookup(tokenMaps) {
    if (!tokenMaps) {
        return (x)=>x;
    }
    let lookupTable;
    return (value)=>{
        if (!lookupTable) {
            lookupTable = createTokenLookupTable(tokenMaps);
        }
        return typeof value === 'string' && value in lookupTable ? lookupTable[value] : value;
    };
}
export function setFormat(value, format) {
    if (format) {
        value.format = format;
    }
    return value;
}
export function property(tokens) {
    const lookup = createTokenLookup(tokens);
    function decorate(fn, formatter) {
        fn.tokens = tokens;
        setFormat(fn, formatter === null || formatter === void 0 ? void 0 : formatter.format);
        return fn;
    }
    function property(toString = (v)=>`${v}`) {
        return decorate((value)=>{
            const v = lookup(value);
            if (isToken(v)) {
                return v.toString();
            } else {
                return toString(v);
            }
        }, toString);
    }
    return {
        alias (name, toString) {
            const fn = property(toString);
            return decorate((value, set)=>{
                set.property(name, fn(value));
            }, fn);
        },
        decorate,
        accept: property,
        transform (transform) {
            return decorate(transform ? transform(lookup) : lookup);
        }
    };
}
export const format = {
    number: (t)=>`${t}`,
    px: setFormat((t)=>typeof t === 'number' ? `${t}px` : `${t}`, 'px'),
    ms: setFormat((t)=>typeof t === 'number' ? `${t}ms` : `${t}`, 'ms'),
    deg: setFormat((t)=>typeof t === 'number' ? `${t}deg` : `${t}`, 'deg')
};

//# sourceMappingURL=util.js.map